module.exports = __webpack_public_path__ + "img/5.420198e5.png";